import React from "react";

import { MetroLogo } from "./MetroLogo";
import { Link } from "react-router";

type Props = {
    to: {
        [x: string]: any;
    };
    country: string;
};

function MetroBackButton(props: Props) {
    const to = props.to;
    if (to) {
        return (
            <Link to={to} className="brandbar-metro-logo navbar-brand">
                <MetroLogo country={props.country} />
            </Link>
        );
    } else {
        return <MetroLogo country={props.country} />;
    }
}

export default MetroBackButton;
